import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TaskService} from '../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {forkJoin, Observable} from 'rxjs';

@Component({
  selector: 'nf-relation-data',
  templateUrl: './relation-data.component.html',
  styleUrls: ['./relation-data.component.css']
})
export class RelationDataComponent implements OnInit {

  @Input() disabled = false;
  visible = false;
  @Input() width = 166;
  boardId;
  boardData: any = {};
  detailModalVisible = false;
  @Input('configs') set configsChange(data) {
    if (data && data.relationData && data.relationData.boardId) {
      this.boardId = data.relationData.boardId;
      this.taskService.getBoardPulses(this.boardId).subscribe((res: any) => {
        this.pulses = res || [];
        this.handleData();
      });
    }
  }
  @Input('nfData') set dataChange(data) {
    if (data && (!this.data || this.data.pulseId != data.pulseId)) {
      this.data = data;
      this.handleData();
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  data = {
    name: '',
    pulseId: ''
  };
  pulses = [];
  pulseData;
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
  }

  tip() {
    this.message.warning('请先选择关联的面板');
  }

  handleData() {
    if (this.data && this.data.pulseId && this.pulses) {
      const index = this.pulses.findIndex(item => item.id == this.data.pulseId);
      index > -1 ?this.data.name = this.pulses[index].name:'';
    }
    if (this.boardId && this.data.name) {
      this.queryPulseData();
    }
  }

  queryPulseData() {
    this.taskService.queryTaskPanel(this.boardId, this.data.name).subscribe(res => {
      if (res) {
        this.boardData = res;
        if (this.boardData.boardData && this.boardData.boardData.pulses) {
          const index = this.boardData.boardData.pulses.findIndex(item => item.id == this.data.pulseId);
          this.pulseData = this.boardData.boardData.pulses[index];
          if (this.pulseData && this.pulseData.columnValues) {
            for (const column of this.boardData.boardData.columns) {
              if (column.type == 'select') {
                this.pulseData.columnValues[column.id] = this.pulseData.columnValues[column.id]?this.pulseData.columnValues[column.id].option:'';
              }
            }
          }
        }
      }
    });
  }

  removeData() {
    this.data = {name: '', pulseId: ''};
    this.nfDataChange.emit(this.data);
  }

  pulseChange(item) {
    this.data.name = item.name;
    this.data.pulseId = item.id;
    this.nfDataChange.emit(this.data);
    if (this.data.pulseId) {
      this.queryPulseData();
    }
  }
}
